import ilComponent from './AgentSelect'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

